import React from 'react';
import { Form, FormProps, FormRenderProps } from 'react-final-form';

import { TransactionsFilterFormValues } from './transactions-filter-form.types';
import { validateFilterForm } from './transactions-filter-form.utils';
import { TransactionsFilterFormContent } from './components/transactions-filter-form-content.component';
import { TransactionsFilterFormActions } from './components/transactions-filter-form-actions.component';

export type TransactionsFilterFormProps = {
  onSubmit: FormProps<TransactionsFilterFormValues>['onSubmit'];
  onReset: () => void;
  initialValues: Partial<TransactionsFilterFormValues>;
  shouldShowFraudCheckStatusFilter?: boolean;
};

export const TransactionsFilterForm: React.FC<TransactionsFilterFormProps> = ({
  onSubmit,
  onReset,
  initialValues,
  shouldShowFraudCheckStatusFilter = false,
}) => {
  const renderForm: FormRenderProps<TransactionsFilterFormValues>['render'] = React.useCallback(
    ({ handleSubmit, form, values }: FormRenderProps<TransactionsFilterFormValues>) => {
      const reset = () => {
        form.reset();
        onReset();
      };

      return (
        <form onSubmit={handleSubmit}>
          <TransactionsFilterFormContent
            values={values}
            shouldShowFraudCheckStatusFilter={shouldShowFraudCheckStatusFilter}
          />

          <TransactionsFilterFormActions onReset={reset} />
        </form>
      );
    },
    [onReset, shouldShowFraudCheckStatusFilter],
  );
  return (
    <Form<TransactionsFilterFormValues>
      onSubmit={onSubmit}
      render={renderForm}
      initialValues={initialValues}
      validate={validateFilterForm}
    />
  );
};
